// PatientData Model
import { Model } from '@vuex-orm/core'

export default class PatientAdmitRxOrderData extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'PatientAdmitRxOrderDatas' 

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id : this.attr(null),
      ipt_order_id : this.attr(null),
      order_no : this.attr(null),
      an : this.attr(null),
      hn : this.attr(null), 
      order_type : this.attr(null),
      rxdate : this.attr(null),
      rxtime : this.attr(null),
      datas : this.attr(null)
    }
  }
}

